const observers = new Map();
let nextObserverId = 0;

export function observeResultViewing(onState) {
    const id = ++nextObserverId;
    let pageLeft = false;
    const update = () => {
        if (pageLeft) return onState("page_left");
        if (document.visibilityState === "hidden") return onState("tab_hidden");
        onState(document.hasFocus() ? "viewing" : "app_inactive");
    };
    // pagehide also fires for reloads and navigation; it cannot confirm a tab close.
    const onPageHide = () => {
        pageLeft = true;
        update();
    };
    const onPageShow = () => {
        pageLeft = false;
        update();
    };
    document.addEventListener("visibilitychange", update);
    window.addEventListener("focus", update);
    window.addEventListener("blur", update);
    window.addEventListener("pagehide", onPageHide);
    window.addEventListener("pageshow", onPageShow);
    observers.set(id, { update, onPageHide, onPageShow });
    update();
    return id;
}

export function stopObservingResultViewing(id) {
    const observer = observers.get(id);
    if (!observer) return;
    const { update, onPageHide, onPageShow } = observer;
    document.removeEventListener("visibilitychange", update);
    window.removeEventListener("focus", update);
    window.removeEventListener("blur", update);
    window.removeEventListener("pagehide", onPageHide);
    window.removeEventListener("pageshow", onPageShow);
    observers.delete(id);
}

export function sendResultViewing(url, key, token, payload) {
    sendGenerationSnapshot(url, key, token, payload, "record_generation_view");
}

export function sendGenerationExit(url, key, token, payload) {
    sendGenerationSnapshot(url, key, token, payload, "record_generation_exit");
}

function sendGenerationSnapshot(url, key, token, payload, rpc) {
    // A scheme-less SDK hostname would otherwise resolve against the app's origin.
    const endpoint = new URL(`/rest/v1/rpc/${rpc}`, url);
    fetch(endpoint.href, {
        method: "POST",
        headers: { "Content-Type": "application/json", apikey: key, Authorization: `Bearer ${token}` },
        body: payload,
        keepalive: true,
    }).then((response) => {
        if (!response.ok) throw new Error(`${rpc} returned HTTP ${response.status}`);
    }).catch((error) => console.warn(`Generation activity recording failed: ${rpc}`, error));
}
